export default __webpack_public_path__ + "static/10-4c4b8de84fe08372e58016c41089f2d6.png";